import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { channelsHandler, handleChannelRemove, handleGroupDevicesFilter, handleReallocateChannels } from './helpers';
import { LoadWidgetHelper } from './loadWidgetHelper';

const loadsInitialState: any = {
    filters: {},
    selectedNodes: [],
    secondary: [],
    viewAllButton: false,
    maxCount: 6,
    isAutomated: true,
    isTotalCountVisible: false,
    countMode: 'custom',
};

const loadsWidgetSlice = createSlice({
    name: 'loads',
    initialState: loadsInitialState,
    reducers: {
        resetLoadsConfiguration: () => {
            return loadsInitialState;
        },
        setPredefinedLoads: (state: RootState, action: PayloadAction<any>) => {
            Object.keys(action.payload)?.forEach((key: string) => {
                if (key === 'selectedNodes') {
                    state[key] = action.payload[key]?.map((item: any) => ({
                        ...item,
                        id: `${item.loadId}${item.deviceId}`?.replace(/-/g, '_'),
                    }));
                } else if (key === 'secondary') {
                    if (typeof action.payload[key][0] === 'string') {
                        state[key] = action.payload[key]?.map((item: any) => ({ loadId: item }));
                    }
                } else state[key] = action.payload[key];
            });
        },
        setLoads: (state: RootState, action: PayloadAction<any>) => {
            channelsHandler(state, action, 'loadId');
        },
        setLoadData: (state: RootState, action: PayloadAction<any>) => {
            state['secondary'] = action.payload;
        },
        setLoadsFilters: (state: RootState, action: PayloadAction<any>) => {
            state['filters'] = action.payload;
        },
        reAllocateLoads: (state: RootState, action: PayloadAction<any>) => {
            handleReallocateChannels(state, action);
        },
        removeLoad: (state: RootState, action: PayloadAction<any>) => {
            handleChannelRemove(state, action, 'loadId');
        },
        setLoadsNodes: (state: RootState, action: PayloadAction<any>) => {
            handleGroupDevicesFilter(state, action);
        },
        setLoadsPreferences: (state: RootState, action: PayloadAction<any>) => {
            LoadWidgetHelper.setPreferences(state, action);
        },
    },
    extraReducers: (builder) => {
        LoadWidgetHelper.addExtraReducers(builder);
    },
});

export const {
    resetLoadsConfiguration,
    setLoadsFilters,
    setLoadsNodes,
    reAllocateLoads,
    setPredefinedLoads,
    removeLoad,
    setLoads,
    setLoadData,
    setLoadsPreferences,
} = loadsWidgetSlice.actions;
export default loadsWidgetSlice;
